(function () {
    'use strict';

    var module = angular.module('uwAgenda.settings.messages');
    module.directive('messageTableRowBooking', ['ItemTableService', 'HelperService', 'AppointmentService', '$uibModal', 'AppointmentRecurrenceUpdateService', 'ProtocolBroadcastService', 'ProtocolFilter', 'Alert', MessageTableRowBookingFn]);

    /* directive for table row in message bookings grid */
    function MessageTableRowBookingFn(ItemTableService, HelperService, AppointmentService, $uibModal, AppointmentRecurrenceUpdateService, ProtocolBroadcastService, ProtocolFilter, Alert) {
        var directive = {
            link: link,
            restrict: 'A',
            replace: true,
            templateUrl: '/app/settings/messages/templates/message-table-row-booking.template.html'
        };
        return directive;

        function link(scope, element, attrs) {
            // if editing -> this is the original backup
            var original = null;

            /* delete is deactivated for now */
            // delete
            scope.delete = function () {
                // delete item
                ItemTableService.deactivate(scope.message, scope.message.vmIndex);
                // delete backend
                deleteBackend();
            };

           
            // call service method to deactivate message
            function deactivateMessage(recurrenceUpdateMethod) {
                AppointmentService.deleteAppointmentById(scope.message.id, recurrenceUpdateMethod).then(function (result) {
                    // show protocol
                    ProtocolBroadcastService.broadcast(ProtocolFilter.ShowOnAppointmentDelete);
                    Alert.success("Item deleted successfully");
                    ItemTableService.remove(scope.message.vmIndex);
                });
            }

            // delete backend
            function deleteBackend() {
                if (!scope.message.vmNew) {
                    if (scope.message.recurrence && scope.message.recurrence.id > 0) {
                        AppointmentRecurrenceUpdateService.getUpdateMethod(scope.message && scope.message.startDate).then(function (recurrenceUpdate) {
                            deactivateMessage(recurrenceUpdate);
                        });
                    }
                    else {
                        deactivateMessage(null);
                    }
                } //if
            }
        }
    }
})();